<template>
	<div>
		<div v-for="(entry, index) in entries" :key="entry.id">

			<div class="video-container uk-padding" style="border: solid 1px #eeeeee; border-radius: 5px; border-bottom: 0; padding-bottom: 0">
					<div class="title">			
						<h2>{{ entry.title }}</h2>
					</div>
					<div class="media uk-margin-top">

						<!-- video -->
						<div v-if="entry.media.type == 'upload'" class="responsive-video uk-border-rounded">
							<video-player
								:id="entry.media.id"
								:ads="false"
								:viewport-observer="true"
								:plays-inline="true"
								:options="{
									aspectRatio: '16:9',
									poster: entry.media.poster,
									sources: [{ src: entry.media.url, type: 'video/mp4' }]
								}">
							</video-player>
						</div>
						
						<!-- html code -->
						<div v-if="entry.media.type == 'html'" class="responsive-video uk-border-rounded">
							<div v-html="entry.media.code"></div>
						</div>
						
					</div>
										
					<!-- footer -->
					<div class="uk-grid-small uk-flex-middle meta" uk-grid>
							
						<div class="uk-width-auto">
							<span class="uk-label">{{ entry.category }}</span>
						</div>
						<div class="uk-width-expand">
						</div>						
						<div class="uk-width-auto uk-text-right">	
							<div class="uk-flex uk-flex-middle uk-flex-right">
															
								<span class="uk-visible@s">DELEN</span>
								<article-share 
									:url="entry.url" 
									:title="entry.title"
									site-name="NieuwNieuws"
									mailto="info@nieuwnieuws.nl"
								></article-share> 
					
								<up-vote 
									ref="voting" 
									:element-id="entry.id"
									:up-votes="entry.votes.totalUpVotes"
									:show-up-vote="true"
									:show-down-vote="false"
									:show-tally-vote="false"
								></up-vote>	
								
								<comments-modal v-if="entry.commenting" 
									:total-comments="entry.totalComments" 
									:url="'/async/comments?id=' + entry.id"
									:js-variables="entry.commentsVariables"
								></comments-modal>

							</div>
						</div>
					</div>
				</div>
		
		</div>
		<div ref="intersectionObserverTarget" class="intersection-observer-target"></div>
		<div class="uk-relative uk-padding-large" v-if="loading">
			<div class="uk-position-center"><LoadingIndicator v-if="loading" /></div>
		</div>
		<div v-if="error" class="error-message">{{ error }}</div>
		<div v-if="noMoreItems" class="uk-alert uk-padding no-more-items-message">
			Geen video's (meer) gevonden, sorry!
		</div>
	</div>
</template>

<script>
import axios from 'axios';
import LoadingIndicator from './LoadingIndicator.vue';
import CommentsModal from './CommentsModal.vue'
import UpVote from './UpVote.vue'
import ArticleShare from './ArticleShare.vue'
import VideoPlayer from './VideoPlayer.vue'

export default {
	components: {
		LoadingIndicator,
		CommentsModal,
		UpVote,
		ArticleShare,
		VideoPlayer
	},
	props: {
		feedUrl: {
			type: String,
			required: true,
		},
		categorySlug: {
			type: String,
			required: false,
			default: ''
		}
	},
	data() {
		return {
			loading: false,
			error: null,
			entries: [],
			page: 1,
			intersectionObserver: null,
			noMoreItems: false, // Track if there are no more items
		};
	},
	mounted() {
		this.setupIntersectionObserver();
		this.fetchentries();
	},
	methods: {
		fetchentries() {
			
			if (this.loading || this.noMoreItems) return;

			var url;
			
			// Add pagination
			url = `${this.feedUrl}/p${this.page}`;
			
			// Add category slug 
			if(this.categorySlug) {
				url = this.$helper.updateQueryStringParameter(url, 'categorySlug', this.categorySlug);
			} 
					
			this.loading = true;

			axios
				.get(url)
				.then((response) => {
					const newItems = response.data.items;
					if (newItems.length < 2) {
						this.noMoreItems = true;
						this.intersectionObserver.disconnect();
					} else {
						this.entries = [...this.entries, ...newItems];
						this.page++;
					}
					this.loading = false;
				})
				.catch((error) => {
					this.error = 'An error occurred while fetching entries.';
					if(error) {
						console.error(error);
					}
					this.loading = false;
				});
		},
		setupIntersectionObserver() {
			this.intersectionObserver = new IntersectionObserver(
				(entries) => {
					const target = entries[0];
					if (target.isIntersecting && !this.loading && !this.error && !this.noMoreItems) {
						this.fetchentries();
					}
				},
				{
					root: null,
					rootMargin: '0px 0px 1000px 0px',
					threshold: 0.1, 
				}
			);

			this.intersectionObserver.observe(this.$refs.intersectionObserverTarget);
		},
	},
};
</script>

<style scoped>
.intersection-observer-target {
	height: 1px;
}
.error-message {
	color: red;
}
.no-more-items-message {
	text-align: center;
	margin-top: 20px;
	font-weight: bold;
}
</style>
